import { Button, Tooltip } from '@mui/material';

type FormActionsProps = {
    isUpdate: boolean;
    disabled?: boolean;
    onSave: () => void;
    onCancel: () => void;
    tooltip?: string;
};

export const FormActions = ({ tooltip = '', isUpdate, disabled = false, onSave, onCancel }: FormActionsProps) => {
    return (
        <>
            <Tooltip title={tooltip} open={Boolean(tooltip)} placement='top' arrow>
                <span>
                    <Button
                        type='submit'
                        disabled={disabled}
                        size={'large'}
                        variant={'contained'}
                        color={'orange'}
                        onClick={onSave}>
                        {!isUpdate ? 'Create' : 'Update'}
                    </Button>
                </span>
            </Tooltip>

            <Button type='button' size={'large'} variant={'outlined'} color={'orange'} onClick={onCancel}>
                Cancel
            </Button>
        </>
    );
};
